import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { DialogProps } from "@toolpad/core/useDialogs";

import { DialogoBaseProps } from "@interfaces/components";

import OkCheck from "@assets/OkCheck.svg";
import InfoIcon from "@mui/icons-material/Info";
import WarningCheck from "@assets/download_warning_icon.svg";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import { ReactNode } from "react";

interface NotificacionProps extends DialogoBaseProps {
    type: "SUCCESS" | "WARNING" | "INFO" | "CONFIRM";
    text: ReactNode;
    okText?: string;
    noText?: string;
    cancelOption?: boolean;
}

export const Notificacion = (props: DialogProps<NotificacionProps, boolean | undefined>) => {
    const getIcon = () => {
        switch (props.payload.type) {
            case "SUCCESS":
                return <img src={OkCheck} height={"65px"} />;
            case "WARNING":
                return <img src={WarningCheck} height={"65px"} />;
            case "INFO":
                return <InfoIcon sx={{ fontSize: 65, alignSelf: "center" }} color="primary" />;
            case "CONFIRM":
                return <HelpOutlinedIcon sx={{ alignSelf: "center", fontSize: 80, color: "#F79E18" }} />;
        }
    };
    return (
        <Dialog fullWidth={props.payload.fullWidth} open={props.open}>
            <DialogTitle>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center"
                    }}>
                    {getIcon()}
                </Box>
            </DialogTitle>
            <DialogContent sx={{ my: 2 }}>
                <Typography
                    variant="body1"
                    sx={{
                        textAlign: "center",
                        fontWeight: 400
                    }}>
                    {props.payload.text}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ mb: 2, justifyContent: "space-around" }}>
                {props.payload.cancelOption && (
                    <Button
                        variant="contained"
                        color="secondary3"
                        size="large"
                        onClick={() => props.onClose?.(undefined)}
                    >
                        Cancelar
                    </Button>
                )}
                {props.payload.type === "CONFIRM" && (
                    <Button
                        variant="blue_outlined"
                        size="large"
                        sx={{ minWidth: "120px" }}
                        onClick={() => props.onClose?.(false)}
                    >
                        {props.payload.noText ?? "Cancelar"}
                    </Button>
                )}
                <Button
                    variant="contained"
                    size="large"
                    sx={{ minWidth: "120px" }}
                    onClick={() => props.onClose?.(true)}
                >
                    {props.payload.okText ?? "Aceptar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
